<style type="text/css">

    /*.myheader {
        margin-right: 30px;
        margin-left: 310px;
        background: #fff;
        border-bottom: 1px solid #e8e9ed;
        box-shadow: none;
        margin-top: 170px;
        padding: 100 30px;
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        z-index: 999;
    }*/

    .tableheader{
        margin-right: 30px;
        margin-left: 510px;
        background: #fff;
        border-bottom: 1px solid #e8e9ed;
        box-shadow: none;
        margin-top: 170px;
        padding: 100 30px;
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        z-index: 999;
    }
</style>
<div class="animated fadeIn">
<div class="row">

    <div class="col-lg-12">
        <div class="card">
            
            <div class="card-body" style="min-height: 600px;">
          
              <div class="row form-group" >
                    <div class="col col-md-12">
                        <div class="card border border-success">
                            <div class="card-header">
                                <div class="row">
                                    <div class="col col-md-2">
                                        <strong class="card-title">File Matrix Filter</strong>
                                    </div>
                                    <div class="col col-md-2">
                                        <select name="dataType" id="dataType" class="form-control-sm form-control" [(ngModel)]="dataType">
                                            <option value="">Data Type</option>
                                            <option value="Segment">Segment</option>
                                            <option value="Form">Form</option>   
                                            <option value="Financial Highlights">Financial Highlights</option>
                                            <option value="Gross & Net Statistics">Gross & Net Statistics</option>
                                            <option value="Data on Motor">Data on Motor</option>
                                            <option value="Reinsurance">Reinsurance</option>
                                            <option value="Large Loss">Large Loss</option>
                                        </select>
                                        <span style="color:red;">{{dataTypeErr}}</span>
                                    </div>
                                    <div class="col col-md-2">
                                        <select name="fileYear" id="fileYear" [(ngModel)]="fileYear" class="form-control-sm form-control" *ngIf="dataType=='Segment'">
                                            <option value="{{yr}}" *ngFor="let yr of yearArr">{{yr}}</option>
                                        </select>
                                        <select name="filefYear" id="filefYear" [(ngModel)]="filefYear" class="form-control-sm form-control" *ngIf="dataType!='Segment'">
                                            <option  value="{{fyr}}" *ngFor="let fyr of yearfArr">{{fyr}}</option>
                                        </select>
                                        <span style="color:red;">{{yrErr}}</span>
                                    </div>
                                    <div class="col col-md-4">
                                        <button type="submit" class="btn btn-primary btn-sm" (click)="searchFile(1)" >Search</button>
                                        &nbsp;
                                        <button (click)="exportToExcel()" class="btn btn-success btn-sm" *ngIf="showDownload">Export To Excel</button> 
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="card-body" > 
                                <div class="row form-group">
                                    <div class="col col-md-2">
                                        <label for="dataType" class=" form-control-label">
                                            <strong>Data Type</strong>
                                        </label>
                                    </div>
                                    <div class="col col-md-2">
                                        <label for="year" class=" form-control-label">
                                            <strong>Year</strong>
                                        </label>
                                    </div>
                                    <div class="col col-md-4">
                                        &nbsp;
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col col-md-2">
                                        <select name="dataType" id="dataType" class="form-control-sm form-control" [(ngModel)]="dataType">
                                            <option>Data Type</option>
                                            <option value="Segment">Segment</option>
                                            <option value="Form">Form</option>   
                                            <option value="Financial Highlights">Financial Highlights</option>
                                            <option value="Gross & Net Statistics">Gross & Net Statistics</option>
                                            <option value="Data on Motor">Data on Motor</option>
                                            <option value="Reinsurance">Reinsurance</option>
                                            <option value="Large Loss">Large Loss</option>
                                        </select>
                                        <span style="color:red;">{{dataTypeErr}}</span>
                                    </div>
                                    <div class="col col-md-2">
                                        <select name="fileYear" id="fileYear" [(ngModel)]="fileYear" class="form-control-sm form-control" *ngIf="dataType=='Segment'">
                                            <option value="{{yr}}" *ngFor="let yr of yearArr">{{yr}}</option>
                                        </select>
                                        <select name="filefYear" id="filefYear" [(ngModel)]="filefYear" class="form-control-sm form-control" *ngIf="dataType!='Segment'">
                                            <option  value="{{fyr}}" *ngFor="let fyr of yearfArr">{{fyr}}</option>
                                        </select>
                                        <span style="color:red;">{{yrErr}}</span>
                                    </div>
                                    <div class="col col-md-4">
                                        <button type="submit" class="btn btn-primary btn-sm" (click)="searchFile(1)" >Search</button>
                                        &nbsp;
                                        <button (click)="exportToExcel()" class="btn btn-success btn-sm" *ngIf="showDownload">Export To Excel</button> 
                                    </div> 
                                </div>
                            </div>-->
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                {{curTimeStr}}
                            </div>
                            <div class="col-md-4">
                                {{fltrStr}}
                            </div>
                        </div>
                    </div>
                </div>
                <table id="bootstrap-data-table" class="table table-striped table-bordered dataTable no-footer" role="grid" aria-describedby="bootstrap-data-table_info" #epltable>
                                           
                    <tbody> 
                    
                        <tr role="row" class="odd" *ngFor="let tr of tabData">
                        	<td *ngFor="let td of tr" [innerHTML]="td"></td>
                        </tr>
                    
                    </tbody>
                </table>
            </div>
        </div>
       


</div>
</div><!-- .animated -->

